import { toYYYYMMDD } from 'scenes/common/helpers/datetime';
import { PolicyHolder } from 'scenes/common/types';
import {
  WireGender,
  WireParty,
  WirePartyType,
  WirePolicyRole,
} from 'scenes/common/api/quote/types';
import { ADDRESS_ID, partyId } from './ids';

export const defaultParty: WireParty = {
  id: '',
  addressRefId: [ADDRESS_ID],
  type: WirePartyType.PolicyHolder,
  role: WirePolicyRole.PrimaryPolicyHolder,
  name: '',
  firstName: '',
  lastName: '',
  middleName: '',
  dob: '',
  gender: WireGender.NA,
  email: '',
  mobile: '',
  abn: '',
  company: '',
  claims: { last3Years: '' },
  numberOfYearsInsured: '',
};

export const mapPrimaryPolicyHolderPerson = (
  firstName: string,
  lastName: string,
  dob: string
) => ({
  id: 'Prt-1',
  name: `${firstName.trim()} ${lastName.trim()}`,
  firstName: firstName.trim(),
  lastName: lastName.trim(),
  dob: toYYYYMMDD(dob),
});

export const mapPrimaryPolicyHolderCompany = (
  firstName: string,
  lastName: string,
  dob: string,
  abn: string,
  businessName: string
) => ({
  ...defaultParty,
  id: 'Company',
  type: WirePartyType.Company,
  name: `${firstName.trim()} ${lastName.trim()}`,
  lastName: lastName.trim(),
  firstName: firstName.trim(),
  company: businessName,
  abn,
  dob: toYYYYMMDD(dob),
});

export const mapAdditionalPolicyHolder = (
  policyHolder: PolicyHolder,
  id: string
): WireParty => ({
  ...defaultParty,
  id,
  addressRefId: [ADDRESS_ID],
  type: WirePartyType.AdditionalPolicyHolder,
  role: WirePolicyRole.PolicyHolder,
  name: `${policyHolder.firstName.trim()} ${policyHolder.lastName.trim()}`,
  lastName: policyHolder.lastName.trim(),
  firstName: policyHolder.firstName.trim(),
  dob: toYYYYMMDD(policyHolder.dob),
});

export const toAdditionalPolicyHolders = (
  additionalPolicyHolders: PolicyHolder[]
): WireParty[] =>
  additionalPolicyHolders.map((policyHolder, idx) =>
    mapAdditionalPolicyHolder(
      policyHolder,
      partyId(idx + additionalPolicyHolders.length)
    )
  );
